module.exports = __webpack_public_path__ + "img/slider-1-person-2.0e331282.png";